import api from "../../api/api";

export const createPartner = async (payload) => {
  const response = await api.post("/users/partner", payload);
  return response.data;
};

export const getAllPartners = async () => {
  const response = await api.get("/users/partner");
  return response.data.data;
};

export const getPartnerById = async (id) => {
  const response = await api.get(`/users/partner/${id}`);
  return response.data;
};

export const updatePartner = (id, payload) => {
  return api.put(`/users/partner/${id}`, payload);
};

export const deletePartner = async (id) => {
  const response = await api.delete(`/users/partner/${id}`);
  return response.data;
};
